import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './LoadingOverlay.module.css';

const LoadingOverlay = ({ isVisible, message = 'Processing...', completed, total, onCancel }) => {
  // Lock body scroll when visible
  useEffect(() => {
    if (isVisible) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
  }, [isVisible]);

  // Calculate progress percentage
  const hasProgress = typeof completed === 'number' && typeof total === 'number' && total > 0;
  const progressPercent = hasProgress ? Math.round((completed / total) * 100) : 0;

  const overlayContent = (
    <div
      className={`${styles.overlay} ${isVisible ? styles.visible : ''}`}
      role="alertdialog"
      aria-busy={isVisible}
      aria-modal="true"
      aria-label={message}
    >
      <div className={styles.contentWrapper}>
        <div className={styles.spinner} aria-hidden="true" />

        <p className={styles.message}>{message}</p>

        {hasProgress && (
          <div className={styles.progressWrapper}>
            <div className={styles.progressTrack}>
              <div
                className={styles.progressFill}
                style={{ width: `${progressPercent}%` }}
                role="progressbar"
                aria-valuenow={completed}
                aria-valuemin={0}
                aria-valuemax={total}
              />
            </div>
            <span className={styles.progressLabel} aria-live="polite">
              {completed} of {total}
            </span>
          </div>
        )}

        {onCancel && (
          <button className={styles.cancelButton} onClick={onCancel} type="button">
            Cancel
          </button>
        )}
      </div>
    </div>
  );

  return createPortal(overlayContent, document.body);
};

export default LoadingOverlay;
